import { fetchAll, fetchFiltered, addComponent, show, edit } from '@/api/component'
import { t } from '@/lib/i18n'
import moment from 'moment' 

const state = {
  all: [],
  isLoading: false,
  componentById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const component = await show(id)
      commit('setComponentById', component)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const components = await fetchAll()
      commit('setAll', components)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const components = await fetchFiltered(queriesParams)
      commit('setAll', components)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addComponent(data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.componentById = null
  },

  setAll (state, components) {
    state.all = components
  },

  setComponentById (state, component) {
    state.componentById = {
      id           : component.id,
      batch        : component.batch,
      itemType     : component.itemType,
      provider     : component.provider,
      nf           : component.nf,
      totalValueNF : component.totalValueNF,
      amountItems  : component.amountItems,
      purchaseDate : moment(component.purchaseDate).format('YYYY-MM-DD'),
      purchaseValue: component.purchaseValue,
      warrantyDate : moment(component.warrantyDate).format('YYYY-MM-DD')
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}